export default "__VITE_ASSET__CfrjYv49__"